import { useTenant } from '@/contexts/TenantContext';
import { hasPermission, isCallCenterRole, type Permission } from '@realvisor/shared';

/**
 * Hook providing role-based permission checks for the current user.
 *
 * Usage:
 *   const { can, isCallCenter, role } = usePermissions();
 *   if (can('contacts:all')) { ... }
 */
export function usePermissions() {
  const { currentTenant } = useTenant();
  const role = currentTenant?.role ?? 'assistant';

  return {
    /** Current user's membership role */
    role,
    /** Check if user has a specific permission */
    can: (permission: Permission) => hasPermission(role, permission),
    /** Whether user is a call center role (cc_operator/cc_supervisor/cc_manager) */
    isCallCenter: isCallCenterRole(role),
  };
}
